import { Controller } from "@hotwired/stimulus"

// A client-side searchable select dropdown.
// Wraps a hidden <select> with a text input + filterable option list.
// Reuses the existing autocomplete-results CSS (hidden when :empty).
export default class extends Controller {
  static targets = ["select", "input", "list"]

  connect() {
    this.buildOptions()
    this.boundClose = this.closeOnOutsideClick.bind(this)
    document.addEventListener("click", this.boundClose)
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose)
  }

  buildOptions() {
    const options = Array.from(this.selectTarget.options)
    this.allOptions = options.map(opt => ({
      value: opt.value,
      label: opt.textContent
    }))

    const selected = options.find(o => o.selected)
    if (selected) {
      this.inputTarget.value = selected.textContent
    }
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase()
    const filtered = this.allOptions.filter(opt =>
      opt.label.toLowerCase().includes(query)
    )
    this.renderList(filtered)
  }

  renderList(options) {
    this.listTarget.innerHTML = ""
    options.forEach(opt => {
      const li = document.createElement("li")
      li.textContent = opt.label
      li.setAttribute("role", "option")
      li.addEventListener("click", () => this.pick(opt))
      this.listTarget.appendChild(li)
    })
  }

  pick(opt) {
    this.inputTarget.value = opt.label
    this.selectTarget.value = opt.value
    this.close()
    this.element.closest("form")?.requestSubmit()
  }

  close() {
    this.listTarget.innerHTML = ""
  }

  showAll() {
    this.renderList(this.allOptions)
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
